import React, { FunctionComponent } from 'react';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { DATA_HOOKS } from '../../../dataHooks';
import searchBarScss from '../index.module.scss';
import { RenderHTML } from '../../RenderHTML';
import css from './index.module.scss';

/**
 * @deprecated use `components/SearchBar/EmptySearchResults/index.tsx` instead
 */
export const DeprecatedEmptySearchResults: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Box
      align="center"
      direction="vertical"
      className={css.emptySearch}
      dataHook={DATA_HOOKS.EMPTY_SEARCH_RESULTS}
    >
      <Box margin="auto" direction="vertical" align="center">
        <Text
          className={`${css.headerMessage} ${searchBarScss.headerMessageEmptySearch}`}
        >
          <RenderHTML
            dataHook={DATA_HOOKS.EMPTY_SEARCH_RESULTS_TEXT}
            html={t('searchbar.empty.result.message')}
          />
        </Text>
      </Box>
      <Text
        className={`${css.footerMessage} ${searchBarScss.footerMessageEmptySearch}`}
      >
        {t('searchbar.empty.result.try.again')}
      </Text>
    </Box>
  );
};
